import React from 'react';
import ad_image from '../../../assets/images/icon/ad.png';
import { ContentsItem } from '../../../modules/editor/types';

type Props = {
	contentItem: ContentsItem
};

function NaverAd({ contentItem }: Props) {
	const imageStyle = contentItem.content.style[0].image;

	return (
		<>
			{
				contentItem.content.column.map((column: string[], index: number) => (
					<div
						key={index}
						className={`content-column column-index-${index}`}
					>
						{
							column.map((row: string, subIndex: number) => (
								<div
									key={subIndex}
									className="content-row"
								>
								{row === 'ad' && (
									<div 
										className="naver-ad-wrapper"
										style={{
											textAlign: imageStyle?.textAlign || 'center'
										}}
									>
										<div className="naver-ad-wrapper-content">
											<img src={ad_image} alt="ad image" />
											<p>광고 배너가 표시됩니다.</p>
										</div>
									</div>
								)}
								</div>
							))
						}
					</div>
				))
			}
		</>
	)
}

export default NaverAd;

